// Messages for the operator create-invoice modal (auto-merged by lib/i18n.ts).
export const en = {
  'operator.invoice_form.title': 'Create invoice',
  'operator.invoice_form.edit_title': 'Edit draft invoice',
  'operator.invoice_form.cancel': 'Cancel',
  'operator.invoice_form.save_draft': 'Save as draft',
  'operator.invoice_form.save_changes': 'Save changes',
  'operator.invoice_form.issue': 'Issue invoice',
  'operator.invoice_form.section.invoice': 'Invoice',
  'operator.invoice_form.section.charges': 'Charges',
  'operator.invoice_form.field.shipment': 'Shipment',
  'operator.invoice_form.field.customer': 'Customer',
  'operator.invoice_form.field.issued_on': 'Issue date',
  'operator.invoice_form.field.due_on': 'Due date',
  'operator.invoice_form.field.currency': 'Currency',
  'operator.invoice_form.field.tax_rate': 'Tax rate (%)',
  'operator.invoice_form.shipment_aria': 'Shipment to bill',
  'operator.invoice_form.shipment_placeholder': 'Select a shipment…',
  'operator.invoice_form.shipment_none': 'No shipment',
  'operator.invoice_form.customer_aria': 'Customer to bill',
  'operator.invoice_form.customer_placeholder': 'Select a customer…',
  'operator.invoice_form.issued_on_aria': 'Issue date',
  'operator.invoice_form.due_on_aria': 'Due date',
  'operator.invoice_form.currency_aria': 'Currency',
}

export const zhTW = {
  'operator.invoice_form.title': '建立發票',
  'operator.invoice_form.edit_title': '編輯草稿發票',
  'operator.invoice_form.cancel': '取消',
  'operator.invoice_form.save_draft': '儲存為草稿',
  'operator.invoice_form.save_changes': '儲存變更',
  'operator.invoice_form.issue': '開立發票',
  'operator.invoice_form.section.invoice': '發票',
  'operator.invoice_form.section.charges': '費用',
  'operator.invoice_form.field.shipment': '貨件',
  'operator.invoice_form.field.customer': '客戶',
  'operator.invoice_form.field.issued_on': '開立日期',
  'operator.invoice_form.field.due_on': '到期日',
  'operator.invoice_form.field.currency': '幣別',
  'operator.invoice_form.field.tax_rate': '稅率（%）',
  'operator.invoice_form.shipment_aria': '要開立的貨件',
  'operator.invoice_form.shipment_placeholder': '選擇貨件…',
  'operator.invoice_form.shipment_none': '無貨件',
  'operator.invoice_form.customer_aria': '要開立的客戶',
  'operator.invoice_form.customer_placeholder': '選擇客戶…',
  'operator.invoice_form.issued_on_aria': '開立日期',
  'operator.invoice_form.due_on_aria': '到期日',
  'operator.invoice_form.currency_aria': '幣別',
}
